import personaControlStore from '../store/Store';
import { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';

export default (personaControlKey: string): PersonaBlobFetchStatus => {
    const viewState = personaControlStore.viewStates.get(personaControlKey);
    const { personaBlob } = viewState;
    return personaBlob && personaBlob.FetchStatus;
};
